import * as React from "react";
import { useMotionValueEvent, useScroll } from "motion/react";

// Put on a page's hero section to let the header's nav items hide once it's scrolled past.
export const HEADER_HERO_ATTR = "data-header-hero";

/**
 * True once the hero's bottom has gone above `navRef`'s bottom edge and the latest scroll
 * was downward; any upward scroll brings the nav back. Pages without a hero never hide it.
 */
export function useNavHiddenPastHero(
    enabled: boolean,
    navRef: React.RefObject<HTMLElement | null>,
    forceVisible: boolean,
): boolean {
    const { scrollY } = useScroll();
    const [hidden, setHidden] = React.useState(false);

    useMotionValueEvent(scrollY, "change", (latest) => {
        if (!enabled) return;
        const previous = scrollY.getPrevious() ?? latest;
        const hero = document.querySelector(`[${HEADER_HERO_ATTR}]`);
        const navBottom = navRef.current?.getBoundingClientRect().bottom ?? 0;
        if (!hero || hero.getBoundingClientRect().bottom > navBottom) {
            setHidden(false);
        } else if (latest > previous) {
            setHidden(true);
        } else if (latest < previous) {
            setHidden(false);
        }
    });

    return enabled && hidden && !forceVisible;
}
